<template>
  <div id="app">
    <common-head v-show="!$route.meta.header"></common-head>
    <router-view class="routerView" />
    <common-foot v-show="!(path === '/partyBuilding')"></common-foot>
    <div class="notice">
      <ul>
        <li v-for="item in list" :key="item.id">
          <a target="_blank" :href="item.url">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CommonHead from "./components/views/Index/header.vue";
import CommonFoot from "./components/views/Index/footer.vue";
import { userApi } from "./api/user.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      path: "",
      list: []
    };
  },
  computed: {
    // ...mapGetters(["requesting", "result", "loginIn", "signFlg"])
  },
  mounted() {
    // userApi.getMenu({ id: 1 }).then(() => {
    //   console.log(1);
    // });
    //  userApi.postMenu({ id: 1 }).then(() => {
    // });
    this.path = this.$route.path;
    this.getAppNotice();
  },
  methods: {
    //  ...mapActions(["openSign"])
    getAppNotice() {
      userApi.getAppNotice().then(res => {
        this.list = res.data.list;
      });
    }
  },
  components: {
    CommonHead,
    CommonFoot
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    }
  }
};
</script>

<style>
#app {
}
.routerView {
  min-height: 600px;
  padding-bottom: 20px;
}
</style>
<style lang="less" scoped>
.notice {
  width: 160px;
  box-sizing: border-box;
  padding: 16px 20px;
  background-color: rgba(60, 163, 242, 0.5);
  border-radius: 10px;
  position: fixed;
  left: 30px;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 111;
  ul {
    li {
      padding: 4px 0;
      text-align: center;
      a {
        line-height: 34px;
        text-align: center;
        color: rgb(17, 40, 84);
        font-size: 14px;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.9);
        display: block;
        border-radius: 2px;
        &:hover {
          background-color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue